import { render, staticRenderFns } from "./StockTracking.vue?vue&type=template&id=9da87938&"
import script from "./StockTracking.vue?vue&type=script&lang=js&"
export * from "./StockTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports